import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
  private readonly CHUNK_LOAD_ERROR = /Loading chunk [\d]+ failed|Failed to fetch dynamically imported module/i;
  private hasReloaded = false;

  handleError(error: any): void {
    const errorMessage = error?.message || error?.toString() || '';
    const chunkFailedMessage = this.CHUNK_LOAD_ERROR;

    // Check if it's a chunk loading error
    if (chunkFailedMessage.test(errorMessage)) {
      // Prevent infinite reload loop
      if (!this.hasReloaded) {
        this.hasReloaded = true;
        console.warn('Chunk loading error detected. Reloading page...', error);
        
        // Clear cache and reload
        this.clearCacheAndReload();
      }
    } else {
      // Log other errors to console
      console.error('Application error:', error);
    }
  }

  private clearCacheAndReload(): void {
    if (typeof window !== 'undefined' && 'caches' in window) {
      caches.keys().then((names: string[]) => {
        const deletePromises = names.map(name => caches.delete(name));
        return Promise.all(deletePromises);
      }).catch(() => {
        // Ignore cache clearing errors
      }).finally(() => {
        this.reloadPage();
      });
    } else {
      this.reloadPage();
    }
  }

  private reloadPage(): void {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  }
}
